module.exports = __webpack_public_path__ + "./images/032e38b612581aff7a04ad5e0319ddcd.webp";